import './style.scss';
import { ReactComponent as RightIcon } from '@assets/images/right.svg';

interface BreadcrumbsProps {
  items: { url: string; children: React.ReactNode }[]
}

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  return (
    <nav className="wly-breadcrumbs">
      {items.map((item, index) => (
        <div key={item.url} className="wly-breadcrumbs__item">
          { index === items.length - 1 ? (
            <span className="text-body-2">{item.children}</span>
          ) : (
            <>
              <a href={item.url} className="text-body-2">{item.children}</a>
              <RightIcon />
            </>
          ) }
        </div>
      ))}
    </nav>
  );
};
